import { useRef } from "react";
import VideoJS from "./VideoJS";
import Player from "video.js/dist/types/player";

const VideoPlayer = ({ src }: { src: string }) => {
    const playerRef = useRef<Player | null>(null);

    const videoJsOptions = {
        theme: "forest", // 'city', 'fantasy', 'forest', 'sea'
        height: 720,
        width: 1280,
        autoPlay: false,
        controls: true,
        loop: false,
        muted: true,
        controlBar: {
            skipButtons: {
                forward: 5,
                backward: 5
            }
        },
        playbackRates: [0.5, 1, 1.5, 2],
        disablePictureInPicture: false,
        sources: [
            {
                src,
                type: "video/mp4"
            }
        ]
    };

    const handlePlayerReady = (player: Player) => {
        playerRef.current = player;

        // You can handle player events here, for example:
        player.on("waiting", () => {
            console.log("player is waiting");
        });

        player.on("dispose", () => {
            console.log("player will dispose");
        });
    };

    return <VideoJS options={videoJsOptions} onReady={handlePlayerReady} />;
};

export default VideoPlayer;
